import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { ProfilUtilisateurService } from 'src/services/profil-utilisateur.service';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { DocumentData } from 'src/models/profil-utilisateur/document-data';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilisateurModel } from 'src/models/utilisateurModel';

const ALLOWED_DOCUMENT_EXTENSIONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'png', 'jpg', 'jpeg', 'gif', 'webp'];

@Component({
    selector: 'app-ajouter-document',
    templateUrl: './ajouter-document.component.html',
    styleUrls: ['./ajouter-document.component.scss'],
    imports: [
    MatIcon,
    FormsModule,
    TranslateModule,
    MatCheckboxModule,
    MatProgressSpinner,
    MatTableModule,
    MatSortModule,
    MatButtonModule
]
})
export class AjouterDocumentComponent implements OnInit {
  estPiloteOuAdmin!: boolean;
  isLoading!: boolean;
  language!: 'FR' | 'EN' | 'ES';
  nom = '';
  file: File | null = null;
  estVisible: boolean = false;
  fileExtension!: string;
  subtitleFile: File | null = null;
  description = '';
  contentType: 'pdf' | 'doc' | 'docx' | 'xls' | 'xlsx' = 'pdf';
  utilisateurId!: number;
  utilisateur?: UtilisateurModel;

  displayedColumns: string[] = [
    'nomFichier',
    'typeFichier',
    'description',
    'nomUtilisateur',
    'extension',
    'actions'
  ];

  pageIndex: number = 0;
  pageSize: number = 10;
  currentPage: number = 0;
  totalItems: number = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  textFilter: string = '';
  textRechercher: string = "";
  isFiltering: boolean = false;

  isDragging = false;
  fileError = '';
  
  constructor(private location: Location,
    private route: ActivatedRoute,
    private router: Router,
    private utilisateurServicePilotage: UtilisateurService,
    private profilUtilisateurService: ProfilUtilisateurService
  ) { }

  ngOnInit() {
    this.estPiloteOuAdmin = this.utilisateurServicePilotage.entiteUtilisateurSelectionnee.roleEntites.some(r => r.roleId === 1 || r.roleId === 2);
    this.route.params.subscribe(params => {
      if (params['id'] !== undefined) {
        this.utilisateurId = params['id'];
        this.utilisateurServicePilotage.obtenirUtilisateurParId(this.utilisateurId)
          .subscribe(utilisateur => {
            this.utilisateur = utilisateur;
          });
      }
    });
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    this.fileError = '';

    const files = event.dataTransfer?.files;
    if (!files?.length) return;

    this.selectFile(files[0]);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.fileError = '';

    if (input.files?.length) {
      this.selectFile(input.files[0]);
    }

    input.value = '';
  }

  private selectFile(file: File): void {
    const extension = file.name.split('.').pop()?.toLowerCase() ?? '';

    if (!ALLOWED_DOCUMENT_EXTENSIONS.includes(extension)) {
      this.file = null;
      this.fileError = 'PROFIL_UTILISATEUR.DOCUMENT_FORMAT_INVALIDE';
      setTimeout(() => this.fileError = '', 3000);

      return;
    }

    this.file = file;
    this.fileExtension = extension;
  }

  removeFile(): void {
    this.file = null;
  }

  saveDocument(): void {
    if (this.file) {
      let documentData: DocumentData = new DocumentData();
      documentData.utilisateurId = this.utilisateurId;
      documentData.createurId = this.utilisateurServicePilotage.selectionEntiteUtilisateur.entiteUtilisateurs[0].utilisateurId;
      documentData.nomFichier = this.nom;
      documentData.estVisible = this.estVisible;
      documentData.extension = this.fileExtension;
      documentData.description = this.description;
      documentData.file = this.file;
      this.isLoading = true;
      this.profilUtilisateurService.uploadDocument(documentData).subscribe((reponse) => {
        this.resetUpload();
        this.goPageListUtilisateur();
      });
    }
  }

  private resetUpload(): void {
    this.file = null;
    this.fileExtension = "";
    this.nom = "";
    this.estVisible = false;
    this.description = "";
  }

  annuler(): void {
    this.location.back();
  }

  goPageListUtilisateur() {
    this.router.navigate(['document-utlisateur/list']);
  }

  retour(): void {
    this.location.back();
  }
}